import { render } from "./buttonshow.vue?vue&type=template&id=4241699a&scoped=true"
import script from "./buttonshow.vue?vue&type=script&lang=js"
export * from "./buttonshow.vue?vue&type=script&lang=js"

import "./buttonshow.vue?vue&type=style&index=0&id=4241699a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4241699a"]])

export default __exports__